import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import LdsButton from "../../components/LdsButton";
import { SideBar } from "../../components/SideBar";
import { useSelector } from "react-redux";

import { ReactLoaderSpinner } from "../../components/ReactLoaderSpinner/index.js";
import References from "../../components/References";
import LdsBlockSteps from "../../components/LdsBlockSteps";
import imageSize from "../../assets/module-2/2-2-3-optimum.png";
import IconArrow from "../../assets/components/blockStep/icon-arrows.svg";
import LdsImage from "../../components/LdsImage";

// services
import { useBookmarkModuleMutation } from "../../store/services/moduleServerApi";

const Module_2_2_3 = () => {
  const { pathname: pathName } = useLocation();
  const { menuItems } = useSelector((state) => state?.moduleSlice);

  const [bookmarkModule, { isLoading: isMenuLoading }] =
    useBookmarkModuleMutation();

  /* Start useEffect */
  useEffect(() => {
    bookmarkModule({ pathName });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // * onPageLoad
  /* End useEffect */

  return (
    <div className="row">
      {isMenuLoading && <ReactLoaderSpinner />}
      {menuItems?.id && <SideBar menuItems={[menuItems]} />}
      <div className="col-sm-8">
        <main className="module-content">
          <section>
            <h1 className="blue text-uppercase b mt-5 mb-4">
              2.2.3 Step 3: Ensure Optimum Size of Images
            </h1>
            <p className="me-4">Estimated time to complete: 1 minute</p>
          </section>

          <section className="row mt-5 mb-3 ms-3">
            <div className="col-md-3 col-sm-12 mb-4 ">
              <LdsBlockSteps
                steps={[
                  {
                    number: 3,
                    color: "gray",
                    icon: IconArrow,
                    text: "Ensure optimum size of images",
                    boxType: "mid",
                  },
                ]}
              />
            </div>
            <div className="col-md-8 col-sm-12 ">
              <LdsImage
                src={imageSize}
                alt="A menu showing options for 'Layout' and 'Color Table,' with sub-options including 'Fusion with MIP,' 'All Planes Fusion,' 'Three Columns,' and 'Dominant Axial."
                className="mb-4"
                style={{ maxWidth: "286px" }}
              />
              <h5 className="b">Ensure optimum size and display of images</h5>
              <ul className="ms-0">
                <li>This is particularly important for transverse images</li>
                <li>
                  Images need to be large enough to examine gray-white matter
                  borders
                </li>

              </ul>
            </div>
          </section>

          <section className="button-control">
            <LdsButton
              classes="white-button mt-3 mb-5 prev"
              onClick={function navClick() {
                window.open("/module-2/module-2-2-2", "_self");
              }}
            >
              Previous Lesson
            </LdsButton>
            <LdsButton
              classes="blue-button mt-3 mb-5 align-self-right float-end next"
              onClick={function navClick() {
                window.open("/module-2/module-2-2-4", "_self");
              }}
            >
              Next Lesson
            </LdsButton>
          </section>

          <References>
            <p className="fz-sm gray">
              Amyvid (florbetapir F 18 injection). Prescribing Information. Lilly USA, LLC.
            </p>
          </References>
        </main>
      </div>
    </div>
  );
};

export default Module_2_2_3;
